import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { updateLocation, updateLunaSettings } from '../../../apiclients/streamsapi_bridge';
import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';

const DeleteHoliday = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    //const [isloading, setIsloading] = useState(false)

    async function removeThisHoliday(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        console.log("delete id :::: " + props.deleteHolidayId)
        if (props.lunaid) {
            await handleDeleteLunaHolidays();
        } else {
            let update = {
                reqid: 37,
                location_id: parseInt(props.locationid),
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                holidays: {
                    remove_holidays: [parseInt(props.deleteHolidayId)],
                }
            }
            console.log("request for delete holiday ::::: " + JSON.stringify(update));
            props.setIsloading(true);
            let saverep = await updateLocation(update);
            setTimeout(() => {
                props.setIsloading(false);
            }, 1000);
            let saverepeMsg = await saverep.json();
            console.log("Reponse for update  call blocking ::::: " + JSON.stringify(saverepeMsg));

            if (saverepeMsg.status && saverepeMsg.status === "success") {
                props.setSuccessMessage(saverepeMsg.message);
                props.addEditFlag(true);
                props.onClose();

            }
        }
    }

    const handleDeleteLunaHolidays = async () => {
        let update = {
            reqid: 149,
            lunaid: props.lunaid ? parseInt(props.lunaid) : "",
            schedule_id: parseInt(props.schedule_id),
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            holidays: {
                remove_holidays: [parseInt(props.deleteHolidayId)],
            }
        }
        console.log("request for delete holiday ::::: " + JSON.stringify(update));
        props.setIsloading(true);
        let saverep = await updateLunaSettings(update);
        setTimeout(() => {
            props.setIsloading(false);
        }, 1000);
        let saverepeMsg = await saverep.json();
        console.log("Reponse for update  call blocking ::::: " + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status === "success") {
            props.setSuccessMessage(saverepeMsg.message);
            props.addEditFlag(true);
            props.onClose();

        }
    }
    return (
        <>
            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}
            <div>
                <span className="phrecording">{t("RemoveHolidaytxt")}</span>
            </div>
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisHoliday(e)}>
                    {t("remove")}</button>
            </div>
            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisHoliday(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
        </>
    );
});

export default DeleteHoliday;
